module.exports = __webpack_public_path__ + "img/deployment-unit.83e79f34.svg";